import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CareerTimeline = ({ careerHistory }) => {
  const [expandedNode, setExpandedNode] = useState(null);

  const toggleNode = (index) => {
    setExpandedNode(expandedNode === index ? null : index);
  };

  const formatDate = (date) => {
    if (!date) return 'Present';
    return new Date(date)?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  if (!careerHistory || careerHistory?.length === 0) {
    return (
      <section className="py-12">
        <h2 className="text-3xl font-bold text-foreground font-headline mb-8">Career Timeline</h2>
        <div className="bg-muted/50 border border-border rounded-lg p-12 text-center">
          <Icon name="Clock" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No career history available yet.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-foreground font-headline mb-8">Career Timeline</h2>
      
      <div className="relative">
        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-border"></div>
        
        <div className="space-y-8">
          {careerHistory?.map((career, index) => (
            <div key={career?.id || index} className="relative pl-20">
              <button
                onClick={() => toggleNode(index)}
                className="absolute left-0 w-16 h-16 bg-primary rounded-full border-4 border-background shadow-lg flex items-center justify-center hover:scale-110 transition-transform z-10"
              >
                <Icon name="Building" size={24} className="text-primary-foreground" />
              </button>
              
              <div
                className={`bg-card border border-border rounded-lg p-6 cursor-pointer hover:shadow-lg transition-all ${
                  expandedNode === index ? 'shadow-xl' : ''
                }`}
                onClick={() => toggleNode(index)}
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-foreground font-headline mb-1">
                      {career?.clubName}
                    </h3>
                    <p className="text-muted-foreground text-sm">
                      {formatDate(career?.startDate)} - {formatDate(career?.endDate)}
                    </p>
                  </div>
                  <Icon
                    name={expandedNode === index ? 'ChevronUp' : 'ChevronDown'}
                    size={24}
                    className="text-muted-foreground"
                  />
                </div>
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                  <div className="bg-muted/50 rounded-lg p-3">
                    <p className="text-xs text-muted-foreground mb-1">Appearances</p>
                    <p className="text-lg font-bold text-foreground">{career?.appearances || 0}</p>
                  </div>
                  <div className="bg-muted/50 rounded-lg p-3">
                    <p className="text-xs text-muted-foreground mb-1">Goals</p>
                    <p className="text-lg font-bold text-foreground">{career?.goals || 0}</p>
                  </div>
                  <div className="bg-muted/50 rounded-lg p-3">
                    <p className="text-xs text-muted-foreground mb-1">Assists</p>
                    <p className="text-lg font-bold text-foreground">{career?.assists || 0}</p>
                  </div>
                  <div className="bg-muted/50 rounded-lg p-3">
                    <p className="text-xs text-muted-foreground mb-1">Position</p>
                    <p className="text-sm font-semibold text-foreground capitalize">{career?.position || 'N/A'}</p>
                  </div>
                </div>
                
                {expandedNode === index && (
                  <div className="border-t border-border pt-4 mt-4 space-y-3 animate-in slide-in-from-top-2">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-muted-foreground mb-1">League</p>
                        <p className="text-foreground font-medium">{career?.league || 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-sm text-muted-foreground mb-1">Country</p>
                        <p className="text-foreground font-medium">{career?.country || 'N/A'}</p>
                      </div>
                      {career?.squadNumber && (
                        <div>
                          <p className="text-sm text-muted-foreground mb-1">Squad Number</p>
                          <p className="text-foreground font-medium">#{career?.squadNumber}</p>
                        </div>
                      )}
                      {career?.contractType && (
                        <div>
                          <p className="text-sm text-muted-foreground mb-1">Contract Type</p>
                          <p className="text-foreground font-medium capitalize">{career?.contractType}</p>
                        </div>
                      )}
                    </div>
                    
                    {career?.achievements && career?.achievements?.length > 0 && (
                      <div>
                        <p className="text-sm text-muted-foreground mb-2">Achievements</p>
                        <div className="flex flex-wrap gap-2">
                          {career?.achievements?.map((achievement, idx) => (
                            <div key={idx} className="bg-success/10 text-success px-3 py-1 rounded-md text-sm font-medium flex items-center gap-1">
                              <Icon name="Trophy" size={14} />
                              {achievement}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {career?.notes && (
                      <div>
                        <p className="text-sm text-muted-foreground mb-1">Notes</p>
                        <p className="text-foreground text-sm">{career?.notes}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareerTimeline;